import { IFacetFilter } from 'Types/Litium';

import CheckBoxIcon from 'Icons/checkbox.svg?url';

interface FilterOptionProps {
    filterIsLoading: boolean;
    option: IFacetFilter;
    selected: boolean;
    filterGroup: string;
    toggleCheckbox: () => void;
    idPrefix: string;
    capitalize?: boolean;
}

const FilterOption = ({
    filterIsLoading,
    option,
    selected,
    filterGroup,
    idPrefix,
    toggleCheckbox,
    capitalize,
}: FilterOptionProps) => (
    <li
        className={`font-sm flex font-roboto text-black transition-opacity duration-layout ${
            filterIsLoading ? 'opacity-60' : 'opacity-100'
        }`}
    >
        <input
            type="checkbox"
            className="peer sr-only"
            id={`${idPrefix}-${option.id}`}
            name={filterGroup}
            checked={selected}
            onChange={() => (filterIsLoading ? false : toggleCheckbox())}
            value={option.id}
            aria-busy={filterIsLoading}
        />
        <label
            style={
                {
                    '--color-code': option.colorHexCode,
                    '--check-box-icon': `url("${CheckBoxIcon}")`,
                } as React.CSSProperties
            }
            className={`flex origin-center select-none items-center gap-2.5 transition-colors duration-layout before:inline-block before:h-4 before:w-4 before:border 
             before:peer-focus:outline ${capitalize ? 'capitalize' : ''} ${
                 option.colorHexCode
                     ? 'relative rounded-full before:h-6 before:w-6 before:rounded-full before:border-black before:bg-[var(--color-code)] after:absolute after:left-0.5 after:h-[calc(100%_-_4px)] after:w-[calc(100%_-_4px)] after:rounded-full after:border-white before:peer-checked:border-black after:peer-checked:border-[3px] after:peer-checked:border-white after:peer-checked:outline after:peer-checked:outline-1 after:peer-checked:outline-offset-[-4px] after:peer-checked:outline-black'
                     : 'before:h-6 before:w-6 before:peer-checked:bg-no-repeat before:peer-checked:[background-image:var(--check-box-icon)]'
             }`}
            htmlFor={`${idPrefix}-${option.id}`}
        >
            {option.colorHexCode ? (
                <span className="sr-only">{option.label}</span>
            ) : (
                <>
                    {capitalize
                        ? option.label.toLowerCase().replace('.', '')
                        : option.label.replace('.', '')}{' '}
                    ({option.quantity})
                </>
            )}
        </label>
    </li>
);

export default FilterOption;
